export const SITE = {
  // YouTube: the "Top of the Funky House" playlist ID (the part after list=).
  // The newest video at the top of that playlist plays in "Latest episode".
  youtubePlaylistId: 'PLIEqn0zn8jPourY0ly-XtBNRKqGKV_I85',
  latestGuestName: 'KATY B',
  latestGuestPhoto: '/assets/katy-b-next.webp',
  nextGuest: 'ANNOUNCED SOON',
  nextGuestPhoto: '/assets/next-guest-soon.webp',

  // Latest viral moment: up to 3 TikTok video links + one line about them.
  // viralFeaturedIndex = which clip gets the big stage; viralStats = that clip's numbers (update as they climb)
  viralReels: [
    'https://www.tiktok.com/@princessnyahandstuff/video/7690943734170520854',
    'https://www.tiktok.com/@princessnyahandstuff/video/7691253894483070230',
    'https://www.tiktok.com/@princessnyahandstuff/video/7666816955592084758'
  ],
  viralFeaturedIndex: 0,
  // Real numbers pulled from TikTok 2026-10-04 — say the word when they climb and I'll refresh
  viralStats: [
    { n: '2M', l: 'VIEWS' },
    { n: '603.4K', l: 'LIKES' },
    { n: '66.9K', l: 'SHARES' },
    { n: '33.1K', l: 'SAVES' },
    { n: '6.2K', l: 'COMMENTS' }
  ],
  viralLine: "This week's clip is doing numbers — full thing lives on TikTok.",

  // Drop slot for the countdown ticker (day: 0=Sun … 1=Mon …, hour: 24h, Europe/London)
  nextDrop: { day: 1, hour: 18 },

  // Guests: newest first. photo = file in /assets, youtube = that episode's link
  guests: [
    { name: 'THEO NASA', photo: '/assets/theo-nasa-next.webp', youtube: 'https://youtu.be/TN7NKjqGy9g' },
    { name: 'KATY B', photo: '/assets/katy-b-next.webp', youtube: 'https://youtu.be/5s-_EML830A' },
    { name: 'COURTNEY COURTNEY', photo: '/assets/courtney-courtney.jpg', youtube: 'https://youtu.be/dZC95YHi8iw' },
    { name: 'DJ NG', photo: '/assets/djng-cover.webp', youtube: 'https://youtu.be/sMysQLcNww4' },
    { name: 'ROSKA', photo: '/assets/roska-cover.webp', youtube: 'https://youtu.be/pC352q5YaAk' },
    { name: 'CRAZY COUSINZ', photo: '/assets/crazy-cousinz-cover.webp', youtube: 'https://youtu.be/xpmvPaOR3Qk' },
    { name: 'DONAEO', photo: '/assets/donaeo-cover.png', youtube: 'https://youtu.be/PxZDAE9-Fp8' }
  ],

  // How it all started
  startedStory:
    "Fresh out of a reformer pilates class, sun out, on a vibe, Princess Nyah couldn't stop thinking about her favourite funky house tunes. So she did what content royalty does: picked up her phone and told the world how dope UK Funky is. A million views later, the people asked for more. So she gave it to them the best way she knows how, sitting down with her music family to talk about the tunes that made them.",
  firstTop10Reels: [
    'https://www.instagram.com/reel/DXeDqIEshJi/',
    'https://www.instagram.com/reel/DXeSx-XsIlr/',
    'https://www.instagram.com/reel/DXexdbSsHDu/',
    'https://www.instagram.com/reel/DXgc9GTsEq4/',
    'https://www.instagram.com/reel/DXgqI0yoWVA/'
  ],
  kizzyReels: [
    'https://www.instagram.com/reel/DZFkCkyoZ8E/',
    'https://www.instagram.com/reel/DZIHIYqIKe-/',
    'https://www.instagram.com/reel/DZIWhsmo3PK/'
  ],

  // SoundCloud tracks/playlists to embed, and your profile
  soundcloud: [
    'https://soundcloud.com/princessnyah/sets/its-funky-baby',
    'https://soundcloud.com/princessnyah/courtney-courtneys-top-ten',
    'https://soundcloud.com/princessnyah/crazy-couzinz-top-10-funky',
    'https://soundcloud.com/princessnyah/donaeo-top-10-funky-tracks'
  ],
  soundcloudProfile: 'https://soundcloud.com/princessnyah',

  // About + socials
  aboutBio:
    "Singer, songwriter and the voice behind Frontline, Big Boys and Hooligans, Princess Nyah has been part of the UK Funky story from the start. These days she's also the founder of Trybe, throwing events for millennials that fuse funky house with a reminder every mum needs to hear: you can want the best for your kids and still be dope doing it. Mums have a life, and Nyah's making sure they get to live it. New music is always on the to-do list, so watch this space.",
  aboutPhoto: '',
  socials: [
    { label: 'TikTok', url: 'https://www.tiktok.com/@princessnyahandstuff' },
    { label: 'YouTube', url: '' },
    { label: 'SoundCloud', url: 'https://soundcloud.com/princessnyah' }
  ],

  // Booking
  bookingEmail: 'info@princessnyah.com',
  bookingTypes: ['DJ sets', 'Hosting', 'Events'],

  // Klaviyo (public site key + list IDs, safe to be public)
  klaviyo: {
    siteKey: 'VzNABX',
    guestListId: 'SnGSmQ', // "ItsFunkyBaby" list
    eventListId: 'XgJuTc', // "Princess Nyah and Friends" list
    djListId: 'XxY2BC', // "DJs" list
    nextPickMetric: 'Next Guest Pick'
  }
};

export const IMAGES = {
  carNight:
    'https://images.unsplash.com/photo-1765914087871-12444522243d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxjYXIlMjBpbnRlcmlvciUyMG5pZ2h0JTIwZHJpdmluZ3xlbnwwfHx8fDE3OTExMDU1Mzl8MA&ixlib=rb-4.1.0&q=85',
  vinyl:
    'https://images.unsplash.com/photo-1603048588665-791ca8aea617?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHw0fHx2aW55bCUyMHJlY29yZCUyMGRhcmt8ZW58MHx8fHwxNzkxMTA1NTM4fDA&ixlib=rb-4.1.0&q=85',
  djCrowd:
    'https://images.unsplash.com/photo-1541126274323-dbac58d14741?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxkaiUyMHBhcnR5JTIwY3Jvd2QlMjBkYXJrfGVufDB8fHx8MTc5MTEwNTUzOHww&ixlib=rb-4.1.0&q=85'
};

export const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
